var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-snackbar',{attrs:{"timeout":_setup.snackbar_info.snackbar_timeout,"top":"","color":_setup.snackbar_info.color},model:{value:(_setup.snackbar_info.snackbar),callback:function ($$v) {_vm.$set(_setup.snackbar_info, "snackbar", $$v)},expression:"snackbar_info.snackbar"}},[_c('span',[_vm._v(_vm._s(_setup.snackbar_info.snackbar_message))])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"1"}},[_c(_setup.BackButton,{on:{"click":function($event){return _vm.$emit('goBackClicked')}}},[_vm._v(" Back To Renovations ")])],1),_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('div',{staticClass:"text-h6 text-center font-weight-bold primary--text"},[_vm._v(" Renovation Details ")])]),_c('v-spacer')],1),_c('v-row',{attrs:{"justify-md":"center"}},[(_vm.$mobileBreakpoint)?_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":_vm.smallScreenHouseDetails.tableHeaders,"items":_vm.smallScreenHouseDetails.houseDetailsEnclosedInArray}})],1):_vm._l((_setup.buildingDetails),function(houseDetailSection,sectionName,index){return _c('v-col',{key:sectionName,attrs:{"cols":"12","md":"6"}},[(index == 0)?_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Building Plan Details")])],1)],1):_vm._e(),_c('v-simple-table',{staticClass:"building_application-details-table",attrs:{"dense":""}},[_c('tbody',_vm._l((houseDetailSection),function(houseAttribute,attributeTitle){return _c('tr',{key:attributeTitle},[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(attributeTitle)+" ")]),_c('td',[(attributeTitle !== 'Occupied')?[_vm._v(" "+_vm._s(houseAttribute))]:[(houseAttribute === true)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-check-circle")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-close")])]],2)])}),0)])],1)})],2),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Reason for Demolishing")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c(_setup.LabelledField,{attrs:{"label":"Demolition Reason","required":""}},[_c('v-textarea',{staticClass:"text-field-background",attrs:{"outlined":"","dense":"","required":"","hide-details":"auto"},model:{value:(_setup.demolitionData.demolition_reason),callback:function ($$v) {_vm.$set(_setup.demolitionData, "demolition_reason", $$v)},expression:"demolitionData.demolition_reason"}})],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Bills and Receipts")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
                {
                    text: 'No.',
                    value: 'id',

                },
                {
                    text: 'Type',
                    value: 'type',

                },
                {
                    text: 'Number',
                    value: 'number',
                    fn: (bills_and_receipts_array) => {
                        if (bills_and_receipts_array.type == 'Bill') {
                            return _setup.bills_and_receipts_object?.bill_number

                        } else if (bills_and_receipts_array.type == 'Receipt') {
                            return _setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.receipt_number

                        }

                        return ''

                    }

                },
                {
                    text: 'date',
                    value: 'Date',
                    fn: (bills_and_receipts_array) => {
                        if (bills_and_receipts_array.type == 'Bill') {
                            return _setup.getFormattedBillDate(_setup.bills_and_receipts_object?.created_at)

                        } else if (bills_and_receipts_array.type == 'Receipt') {
                            if (_setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.payment_date) {
                                return _setup.getFormattedBillDate(_setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.payment_date)
                            }

                        }

                        return ''

                    }

                },
                {
                    text: 'amount',
                    value: 'Amount',
                    fn: (bills_and_receipts_array) => {
                        if (bills_and_receipts_array.type == 'Bill') {
                            return _setup.getFormattedMoney(_setup.bills_and_receipts_object?.amount)

                        } else if (bills_and_receipts_array.type == 'Receipt') {
                            return _setup.getFormattedMoney(_setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.amount)

                        }

                        return ''

                    }

                },
                {
                    text: 'status',
                    action: true,
                    value: 'status',

                },

                {
                    text: 'Download',
                    value: 'download',
                    action: true

                },


            ],"dense":"","items":_setup.bills_and_receipts_array,"bodyClasses":"text-caption"},scopedSlots:_vm._u([{key:"item.status",fn:function({ item: bills_and_receipts_array_item }){return [_c('span',{class:{
                        'font-weight-bold': true,
                        'green--text': _setup.checkIfBillReceiptPaid(bills_and_receipts_array_item.type),
                        'red--text': !_setup.checkIfBillReceiptPaid(bills_and_receipts_array_item.type),
                    }},[_vm._v(_vm._s(_setup.returnBillReceiptString(bills_and_receipts_array_item.type)))])]}},{key:"item.download",fn:function({ item: bills_and_receipts_array_item }){return [(bills_and_receipts_array_item.type == 'Bill')?_c(_setup.ActionButton,{attrs:{"action":_setup.actions.downloadBill,"inTable":""},on:{"click":function($event){return _setup.onDownloadBillClicked(bills_and_receipts_array_item)}}}):_c(_setup.ActionButton,{attrs:{"action":_setup.actions.downloadReceipt,"inTable":""},on:{"click":function($event){return _setup.onDownloadReceiptClicked(bills_and_receipts_array_item)}}})]}}])})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Workflow")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
      {
        text: 'User',
        value: 'user',
      },
      {
        text: 'Role',
        value: 'role',
      },
      {
        text: 'Action',
        value: 'action',
      },
      {
        text: 'Comment',
        value: 'comment',
      },
      {
        text: 'Approval Date',
        value: 'actioned',
      },

    ],"dense":"","items":_setup.workflow_approvers_array,"bodyClasses":"text-caption"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }